import point from "assets/images/linPingQuMapPoint.png"
const mapJSON = [
  {
    featureType: "land",
    elementType: "geometry",
    stylers: {
      color: "#1e2f61ff",
      visibility: "on"
    }
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: {
      color: "#1e2f61ff",
      visibility: "on"
    }
  },
  {
    featureType: "building",
    elementType: "geometry.fill",
    stylers: {
      color: "#132352ff",
      visibility: "on"
    }
  },
  {
    featureType: "building",
    elementType: "geometry.stroke",
    stylers: {
      color: "#041139ff",
      visibility: "on"
    }
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "village",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "town",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "district",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "country",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "city",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "continent",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "poilabel",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "poilabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "transportationlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "transportationlabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "airportlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#032963ff",
      visibility: "on"
    }
  },
  {
    featureType: "airportlabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: {
      visibility: "on",
      color: "#4a90e2ff"
    }
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: {
      weight: 3,
      visibility: "on"
    }
  },
  {
    featureType: "green",
    elementType: "geometry",
    stylers: {
      color: "#375f92ff",
      visibility: "on"
    }
  },
  {
    featureType: "scenicspots",
    elementType: "geometry",
    stylers: {
      color: "#1e2f61ff",
      visibility: "on"
    }
  },
  {
    featureType: "scenicspots",
    elementType: "labels.text.fill",
    stylers: {
      color: "#548ce0ff",
      visibility: "on"
    }
  },
  {
    featureType: "scenicspots",
    elementType: "labels.text.stroke",
    stylers: {
      weight: 1,
      color: "#5f8566ff",
      visibility: "on"
    }
  },
  {
    featureType: "continent",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "country",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "city",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "city",
    elementType: "labels.icon",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "airportlabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "transportationlabel",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "railway",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "subway",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "highwaysign",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "nationalwaysign",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "nationalwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "provincialwaysign",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "provincialwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "tertiarywaysign",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "tertiarywaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "subwaylabel",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "subwaylabel",
    elementType: "labels.icon",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on",
      weight: 90,
      color: "#f1e8e8ff"
    }
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 0,
      opacity: "00"
    }
  },
  {
    featureType: "shopping",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "scenicspots",
    elementType: "labels",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "scenicspotslabel",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "manmade",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "manmade",
    elementType: "labels",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "highwaysign",
    elementType: "labels.icon",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#375f9200",
      visibility: "on"
    }
  },
  {
    featureType: "road",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "road",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "road",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "road",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "road",
    elementType: "labels.text",
    stylers: {
      fontsize: 24
    }
  },
  {
    featureType: "highway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 0,
      opacity: "00"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1c4f7eff"
    }
  },
  {
    featureType: "highway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry",
    stylers: {
      weight: 3
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#1c4f7eff"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1,
      opacity: "00"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      weight: 3
    }
  },
  {
    featureType: "provincialway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "arterial",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "tertiaryway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "fourlevelway",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "local",
    elementType: "geometry.fill",
    stylers: {
      color: "#3769a1ff",
      visibility: "on"
    }
  },
  {
    featureType: "provincialway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "arterial",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "tertiaryway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "fourlevelway",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "local",
    elementType: "geometry.stroke",
    stylers: {
      color: "#194679ff",
      visibility: "on"
    }
  },
  {
    featureType: "local",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "local",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1,
      opacity: "00"
    }
  },
  {
    featureType: "fourlevelway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "tertiaryway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "arterial",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "provincialway",
    elementType: "labels.text.fill",
    stylers: {
      visibility: "on"
    }
  },
  {
    featureType: "provincialway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1,
      opacity: "00"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 0,
      opacity: "00"
    }
  },
  {
    featureType: "arterial",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#4a90e2ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "tertiaryway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 0
    }
  },
  {
    featureType: "fourlevelway",
    elementType: "labels.text.stroke",
    stylers: {
      color: "#5f8566ff",
      visibility: "on",
      weight: 1
    }
  },
  {
    featureType: "fourlevelway",
    elementType: "geometry",
    stylers: {
      weight: 1
    }
  },
  {
    featureType: "tertiaryway",
    elementType: "geometry",
    stylers: {
      weight: 1
    }
  },
  {
    featureType: "local",
    elementType: "geometry",
    stylers: {
      weight: 1
    }
  },
  {
    featureType: "provincialway",
    elementType: "geometry",
    stylers: {
      weight: 3
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      weight: 3
    }
  },
  {
    featureType: "arterial",
    elementType: "geometry",
    stylers: {
      weight: 3
    }
  },
  {
    featureType: "highway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "highway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "highway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "highway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "highway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "highway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "highway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "highway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "highway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "nationalway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "nationalway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "nationalway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "provincialway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8"
    }
  },
  {
    featureType: "provincialway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9"
    }
  },
  {
    featureType: "provincialway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8"
    }
  },
  {
    featureType: "provincialway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9"
    }
  },
  {
    featureType: "provincialway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "8"
    }
  },
  {
    featureType: "provincialway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "8,10",
      level: "9"
    }
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "cityhighway",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "6"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "7"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "8"
    }
  },
  {
    featureType: "cityhighway",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "6,9",
      level: "9"
    }
  },
  {
    featureType: "arterial",
    stylers: {
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9"
    }
  },
  {
    featureType: "arterial",
    elementType: "geometry",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9"
    }
  },
  {
    featureType: "arterial",
    elementType: "labels",
    stylers: {
      visibility: "off",
      curZoomRegionId: "0",
      curZoomRegion: "9,9",
      level: "9"
    }
  },
  {
    featureType: "playground",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "estate",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "medical",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "scenicspotsway",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "universityway",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "vacationway",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "laneline",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "parkingspace",
    elementType: "geometry",
    stylers: {
      visibility: "off"
    }
  },
  {
    featureType: "subwaystation",
    elementType: "geometry",
    stylers: {
      color: "#aca350ff"
    }
  },
  {
    featureType: "districtlabel",
    elementType: "labels.text.stroke",
    stylers: {
      weight: 0.2
    }
  },
  {
    featureType: "districtlabel",
    elementType: "labels.text.fill",
    stylers: {
      color: "#b8e986ff"
    }
  }
]
class linPingQuBaiDuDiTu {
  constructor(vue) {
    this.vue = vue
    this.wrapperName = "linPingQuBaiDuDiTu"
    this.wrapper = null
  }
  init() {
    this.clearWrapper()
    this.initWrapper()
    this.initScript().then(res => {
      this.initEcharts()
    })
  }
  initScript() {
    return new Promise((resolve, reject) => {
      const script = this.createScript()
      const link = this.createLink()
      let count = 0
      if (script) {
        document.body.appendChild(script)
        count++
      }
      if (link) {
        document.body.appendChild(link)
        count++
      }
      link.onload = function () {
        count--
        if (count === 0) resolve("allLoad")
      }
      script.onload = function () {
        count--
        if (count === 0) resolve("allLoad")
      }
    })
  }
  createScript() {
    const script = document.createElement("script")
    const scriptSrc =
      "//api.map.baidu.com/getscript?type=webgl&v=1.0&ak=aG5nWGO5m5tkVhBHGuVppoIRfKbyp5H3&services=&t=20220914213950"
    script.setAttribute("src", scriptSrc)
    script.setAttribute("async", "async")
    return script
  }
  createLink() {
    const link = document.createElement("link")
    const url = "//api.map.baidu.com/res/webgl/10/bmap.css"
    link.setAttribute("rel", "stylesheet")
    link.setAttribute("type", "text/css")
    link.setAttribute("href", url)
    return link
  }
  initEcharts() {
    const scatterData = {
      临平区文化馆: [120.292744, 30.385505],
      塘栖镇分馆: [120.191159, 30.473967],
      星桥街道分馆: [120.251723, 30.392976],
      乔司街道分馆: [120.294691, 30.347951],
      运河街道分馆: [120.304992, 30.498861],
      崇贤街道分馆: [120.166568, 30.381934],
      东湖街道分馆: [120.28047, 30.425215],
      临平街道分馆: [120.308945, 30.440734],
      南苑街道分馆: [120.318624, 30.404651],
      "亭趾社区“临品艺站”": [120.300858, 30.459168],
      '胜稼村“临品艺站”"': [120.282772, 30.325905],
      "塘栖村“临品艺站”": [120.19281, 30.454747],
      "丁山河村“临品艺站”": [120.185642, 30.44719],
      "曹家浜社区“临品艺站”": [120.174766, 30.387594],
      "庙东社区“临品艺站”": [120.306418, 30.424185],
      "小林社区“临品艺站”": [120.281546, 30.43534],
      "新梅社区“临品艺站”": [120.29856, 30.367757]
    }
    const map = new BMapGL.Map(this.wrapper) // 创建Map实例
    map.centerAndZoom(new BMapGL.Point(120.242744, 30.405505), 13) // 初始化地图,设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
    map.setMapStyleV2({ styleJson: mapJSON })

    for (let k in scatterData) {
      // // 创建Marker标注，使用小车图标
      var marker = new BMapGL.Marker(new BMapGL.Point(...scatterData[k]), {
        icon: new BMapGL.Icon(point, new BMapGL.Size(10, 10))
      })
      var label = new BMapGL.Label(k, {
        offset: new BMapGL.Size((0 - k.length / 2) * 10, 3)
      })
      label.setStyle({
        color: "rgb(187,225,106)",
        background: "transparent",
        fontSize: "10px",
        border: "none"
      })
      marker.setLabel(label)
      map.addOverlay(marker)
    }
  }
  initWrapper() {
    const el = document.createElement("div")
    el.style.width = "100%"
    el.style.height = "100%"
    el.id = this.wrapperName
    this.wrapper = el
    this.vue.$el.appendChild(el)
  }
  clearWrapper() {
    this.vue.$el.innerHTML = ""
    this.vue.$el.style.padding = "0"
  }
}
export default {
  data() {
    return {
      linPingQuBaiDuDiTu: new linPingQuBaiDuDiTu(this)
    }
  },
  methods: {
    linPingQuBaiDuDiTuPlugin() {
      this.$nextTick(() => {
        this.linPingQuBaiDuDiTu.init()
      })
    }
  }
}
